import { DepartmentApi } from 'api/DepartmentApi';
import { apiClient } from 'container/apiClient';

export const departmentApi = new DepartmentApi(apiClient);
